import { operatorApiFetch } from './apiService';

export const userInvitationService = {
  // 列表
  fetchList: async (merchantId) => {
    const response = await operatorApiFetch(`merchants/${merchantId}/user_invitations`, { method: 'GET' });
    return response.json();
  },

  // 創建
  create: async (merchantId, data) => {
    const response = await operatorApiFetch(`merchants/${merchantId}/user_invitations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // 重新發送
  regenerate: async (merchantId, id) => {
    const response = await operatorApiFetch(`merchants/${merchantId}/user_invitations/${id}/regenerate`, {
      method: 'POST',
    });
    return response.json();
  },

  // 刪除
  delete: async (merchantId, id) => {
    const response = await operatorApiFetch(`merchants/${merchantId}/user_invitations/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },
};

export default userInvitationService;
